import { render, staticRenderFns } from "./CategoryAutocomplete.vue?vue&type=template&id=2ad687be&"
import script from "./CategoryAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CategoryAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports